export const penjemputOpt = [
    { value: "Ayah", label: "Ayah" },
    { value: "Ibu", label: "Ibu" },
    { value: "Kakek", label: "Kakek" },
    { value: "Nenek", label: "Nenek" },
    { value: "Kakak", label: "Kakak" },
    { value: "Adik", label: "Adik" },
    { value: "Lainnya", label: "Lainnya" },
]